import type { ActiveLocationGroup } from "@/lib/timeline/location";
import { debuggablesForOnStageLocationStack } from "@/lib/timeline/location";
import type { BoardModelDebugMeasureContext } from "../measurable";
import {
  syncBoardModelDebuggables,
  type EnsureDebugFrame,
} from "../sync";
import type { DebugFrameIdSets } from "../register";
import { updateLocationCohortLabel } from "../ActiveLocationGroup/cohortLabel";
import {
  trunkBranchesNeedingOnStageDebug,
  trunkOnStagePlaceLabels,
  trunkOnStageStacks,
  trunkCharacterIdsOnBranch,
  trunkVisiblePartRunIds,
} from "./trunk";

export function applyTrunkActiveLocationGroupDebug(
  host: HTMLElement,
  context: BoardModelDebugMeasureContext,
  groups: readonly ActiveLocationGroup[],
  idSets: DebugFrameIdSets,
  ensureFrame: EnsureDebugFrame,
): void {
  const layout = context.layout;
  const playheadMs = context.playheadMs;
  for (const branchId of trunkBranchesNeedingOnStageDebug(
    layout,
    playheadMs,
    groups,
  )) {
    const { primaryRunId, onStageSecondaryRunIds } = trunkOnStageStacks(
      layout,
      playheadMs,
      branchId,
    );
    const onStageRuns = [
      ...(primaryRunId === undefined ? [] : [primaryRunId]),
      ...onStageSecondaryRunIds,
    ];
    const debuggables = debuggablesForOnStageLocationStack({
      labelsId: `trunk:${branchId}:labels`,
      locationFrameId: `trunk:${branchId}`,
      onStageRunIds: onStageRuns,
      characterIds: trunkCharacterIdsOnBranch(layout.rail, playheadMs, branchId),
      primaryRunId,
      onStageSecondaryRunIds,
      visiblePartRunIds: trunkVisiblePartRunIds(layout, playheadMs, branchId),
    });
    if (debuggables.length === 0) {
      continue;
    }
    syncBoardModelDebuggables(host, ensureFrame, debuggables, context, idSets);
    updateLocationCohortLabel(
      context.world,
      `trunk:${branchId}`,
      trunkOnStagePlaceLabels(layout, primaryRunId, onStageSecondaryRunIds),
    );
  }
}
